import { cn } from "@/lib/utils";

export function Input({ className, ...props }: React.ComponentProps<"input">) {
  return <input className={cn("rounded-md border border-gray-300 bg-white px-3 py-2 text-sm dark:border-white/20 dark:bg-[#12161d] dark:text-white", className)} {...props} />;
}
